import { Observable } from "rxjs";
import { Service } from "typedi";
import { DomMethods } from "../../../application/core/shared/dom-methods/DomMethods";
import { ICardinal } from "./ICardinal";
import { ICardinalProvider } from "./ICardinalProvider";
import { CardinalLoadStrategyFactory } from "./CardinalLoadStrategyFactory";
import { CardinalConfigFactory } from "./CardinalConfigFactory";
import { CardinalLoadMode } from "./CardinalLoadMode";

@Service()
export class CardinalProvider implements ICardinalProvider {
  private static readonly containerId = "Cardinal-ElementContainer";

  constructor(private strategyFactory: CardinalLoadStrategyFactory) {}

  /**
   * Loads Cardinal Commerce SDK with version selection based on environment.
   *
   * Current behaviour (Phase 1):
   * - Production (liveStatus=true): Uses V1 directly
   * - Staging (liveStatus=false): Attempts V2 with SRI, falls back to V1 on failure
   *
   * @param liveStatus - true for production, false for staging
   * @returns Observable that emits Cardinal instance when initialised
   */
  getCardinal$(liveStatus: boolean): Observable<ICardinal> {
    this.applyMobileStyles();

    const config = CardinalConfigFactory.getConfig();
    const mode = CardinalLoadMode.V2_WITH_FALLBACK;
    const strategy = this.strategyFactory.create(mode, liveStatus, config);

    return strategy.load();
  }

  private applyMobileStyles(): void {
    const mobileViewStyles = `
      @media only screen and (max-width: 450px) {
        #${CardinalProvider.containerId} iframe#Cardinal-CCA-IFrame {
          width: 100vw;
        }
      }
    `;
    DomMethods.insertStyle(mobileViewStyles);
  }
}
